// Relative path to monorepo shared helpers (Cloudflare Pages-safe).
import { goLobby as go, takeTokenFromUrl as take } from '../../shared/lobby.ts'

export function goLobby(token: string | null | undefined) {
  go(token, import.meta.env.VITE_LOBBY_URL as string | undefined)
}

export function takeTokenFromUrl(): string | null {
  return take()
}
